// src/config/notificationPusherConfig.js
const notificationPusherConfig = {
  key: '949bc21753f290661ac0',
  cluster: 'ap1',
}
export default notificationPusherConfig